import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import ReactGoogleMapLoader from 'react-google-maps-loader';
import { isEqual } from 'lodash';
import { validate } from 'wix-rich-content-common';
import pluginMapSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-map.schema.json';

const MAP_TYPE = "wix-draft-plugin-map";

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const GoogleMapWrapper = withGoogleMap((props) => /* @__PURE__ */ React.createElement(
  GoogleMap,
  {
    defaultCenter: { lat: props.lat, lng: props.lng },
    center: { lat: props.lat, lng: props.lng },
    zoom: props.zoom,
    options: {
      draggable: props.isDraggingAllowed,
      mapTypeId: props.mode,
      zoomControl: props.isZoomControlShown,
      streetViewControl: props.isStreetViewControlShown,
      mapTypeControl: props.isViewControlShown
    }
  },
  /* @__PURE__ */ React.createElement(
    Marker,
    {
      options: { visible: props.isMarkerShown },
      title: props.markerTitle,
      position: { lat: props.lat, lng: props.lng },
      onClick: props.onMarkerClick
    },
    props.isMarkerTooltipRendered && props.markerTooltipContent.trim() !== "" && /* @__PURE__ */ React.createElement(InfoWindow, { onCloseClick: props.onMarkerTooltipCloseClick }, /* @__PURE__ */ React.createElement("p", { style: { margin: 0 } }, props.markerTooltipContent))
  )
));
class MapViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "setRootElementRef", (elm) => this.element = elm);
    __publicField(this, "onClick", () => {
      var _a, _b;
      return (_b = (_a = this.props.helpers).onViewerAction) == null ? void 0 : _b.call(_a, MAP_TYPE, "Click");
    });
    this.state = {
      isMarkerTooltipRendered: true
    };
    validate(props.componentData, pluginMapSchema);
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginMapSchema);
    }
  }
  componentDidMount() {
    if (!this.props.componentData.config.width) {
      if (this.props.settings && this.props.settings.width) {
        this.props.componentData.config.width = this.props.settings.width;
      } else if (this.element) {
        const { width } = this.element.getBoundingClientRect();
        this.props.componentData.config.width = width;
      }
    }
    if (!this.props.componentData.config.height) {
      if (this.props.settings && this.props.settings.height) {
        this.props.componentData.config.height = this.props.settings.height;
      }
    }
  }
  render() {
    const {
      componentData: { mapSettings, config: { width, height } = {} },
      settings: { googleMapApiKey } = {}
    } = this.props;
    const style = {
      width: this.props.isMobile ? "auto" : width,
      height,
      whiteSpace: "initial"
    };
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ React.createElement("div", { ref: this.setRootElementRef, style, "data-hook": "mapViewer", onClick: this.onClick }, /* @__PURE__ */ React.createElement(
        ReactGoogleMapLoader,
        {
          params: {
            key: googleMapApiKey || "",
            libraries: "geometry,drawing,places"
          },
          render: (googleMaps) => googleMaps && /* @__PURE__ */ React.createElement(
            GoogleMapWrapper,
            __spreadValues$1({
              isMarkerShown: mapSettings.isMarkerShown,
              loadingElement: /* @__PURE__ */ React.createElement("div", { style: { height: `100%` } }),
              containerElement: /* @__PURE__ */ React.createElement("div", { style }),
              mapElement: /* @__PURE__ */ React.createElement("div", { style: { height: `100%` } }),
              lat: Number(mapSettings.lat),
              lng: Number(mapSettings.lng),
              markerTitle: mapSettings.address,
              markerTooltipContent: mapSettings.locationDisplayName,
              zoom: mapSettings.zoom,
              onMarkerTooltipCloseClick: () => this.setState({ isMarkerTooltipRendered: false }),
              onMarkerClick: () => this.setState({ isMarkerTooltipRendered: !this.state.isMarkerTooltipRendered }),
              isMarkerTooltipRendered: this.state.isMarkerTooltipRendered,
              mode: mapSettings.mode,
              isZoomControlShown: mapSettings.isZoomControlShown,
              isStreetViewControlShown: mapSettings.isStreetViewControlShown,
              isViewControlShown: mapSettings.isViewControlShown,
              isDraggingAllowed: mapSettings.isDraggingAllowed
            }, this.props)
          )
        }
      ))
    );
  }
}
MapViewer.propTypes = {
  componentData: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  settings: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    googleMapApiKey: PropTypes.string,
    mapSettings: PropTypes.object
  }).isRequired,
  helpers: PropTypes.object
};

const typeMapper = () => ({
  [MAP_TYPE]: { component: MapViewer }
});

const DEFAULTS = Object.freeze({
  size: "content",
  alignment: "center",
  width: 400,
  height: 400,
  minHeight: 100,
  maxHeight: 1e3,
  minWidth: 100,
  maxWidth: 1e3,
  config: {
    width: 400,
    height: 400,
    minHeight: 100,
    maxHeight: 1e3,
    minWidth: 100,
    maxWidth: 1e3,
    mapSettings: {
      address: "Wix HQ, Nemal Tel Aviv Street, Tel Aviv-Yafo, Israel",
      locationDisplayName: "Wix HQ, Nemal Tel Aviv Street, Tel Aviv-Yafo, Israel",
      lat: 32.097235,
      lng: 34.77427,
      zoom: 18,
      mode: "roadmap",
      isMarkerShown: true,
      isZoomControlShown: true,
      isStreetViewControlShown: true,
      isDraggingAllowed: true
    }
  }
});

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginMap = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: MAP_TYPE,
    typeMapper
  };
};

export { MAP_TYPE, typeMapper as mapTypeMapper, pluginMap };
//# sourceMappingURL=viewer.js.map
